/*
insert into i10rs (
  _key,_vsn,_ltt,_fst,
  _dmn,i10r_31r1f,
  _icn,_pfx,
  i10ri11r1f,
  i10rt1100i,
  i10ra1100i,
  i10ra2100i,
  "createdAt","updatedAt",_dlt
) VALUES (
  1,1,1,1,
  1,1,
  '1','会議室A',
  1,
  10,
  2,
  100,
  '2000-01-01 00:00:00','2000-01-01 00:00:00',-1
);

insert into i101s (
  _key,_vsn,_ltt,_fst,
  _dmn,i101_31r1f,
  _icn,_pfx,
  i101i10r1k,
  i101i1111f,
  i101a1111i,i101a1112i,i101a1113i,
  i101a1121i,i101a1122i,i101a1123i,
  i101a1211i,i101a1212i,i101a1213i,
  i101a1221i,i101a1222i,i101a1223i,
  "createdAt","updatedAt",_dlt
) VALUES (
  11,1,1,11,
  1,1,
  '1', '午前',
  1,
  11,
  300,300,300, 300,300,300, 300,300,300, 300,300,300,
  '2000-01-01 00:00:00','2000-01-01 00:00:00',-1
);

insert into i101s (
  _key,_vsn,_ltt,_fst,
  _dmn,i101_31r1f,
  _icn,_pfx,
  i101i10r1k,
  i101i1111f,
  i101a1111i,i101a1112i,i101a1113i,
  i101a1121i,i101a1122i,i101a1123i,
  i101a1211i,i101a1212i,i101a1213i,
  i101a1221i,i101a1222i,i101a1223i,
  "createdAt","updatedAt",_dlt
) VALUES (
  12,1,1,12,
  1,1,
  '2', '午後1',
  1,
  12,
  300,300,300, 300,300,300, 300,300,300, 300,300,300,
  '2000-01-01 00:00:00','2000-01-01 00:00:00',-1
);

insert into i101s (
  _key,_vsn,_ltt,_fst,
  _dmn,i101_31r1f,
  _icn,_pfx,
  i101i10r1k,
  i101i1111f,
  i101a1111i,i101a1112i,i101a1113i,
  i101a1121i,i101a1122i,i101a1123i,
  i101a1211i,i101a1212i,i101a1213i,
  i101a1221i,i101a1222i,i101a1223i,
  "createdAt","updatedAt",_dlt
) VALUES (
  13,1,1,13,
  1,1,
  '3', '午後2',
  1,
  13,
  300,300,300, 300,300,300, 300,300,300, 300,300,300,
  '2000-01-01 00:00:00','2000-01-01 00:00:00',-1
);

insert into i101s (
  _key,_vsn,_ltt,_fst,
  _dmn,i101_31r1f,
  _icn,_pfx,
  i101i10r1k,
  i101i1111f,
  i101a1111i,i101a1112i,i101a1113i,
  i101a1121i,i101a1122i,i101a1123i,
  i101a1211i,i101a1212i,i101a1213i,
  i101a1221i,i101a1222i,i101a1223i,
  "createdAt","updatedAt",_dlt
) VALUES (
  14,1,1,14,
  1,1,
  '4', '夕方',
  1,
  14,
  300,300,300, 300,300,300, 300,300,300, 200,200,200,
  '2000-01-01 00:00:00','2000-01-01 00:00:00',-1
);

insert into i10rs (
  _key,_vsn,_ltt,_fst,
  _dmn,i10r_31r1f,
  _icn,_pfx,
  i10ri11r1f,
  i10rt1100i,
  i10ra1100i,
  i10ra2100i,
  "createdAt","updatedAt",_dlt
) VALUES (
  2,1,1,2,
  1,1,
  '2','会議室B',
  1,
  10,
  2,
  100,
  '2000-01-01 00:00:00','2000-01-01 00:00:00',-1
);

insert into i101s (
  _key,_vsn,_ltt,_fst,
  _dmn,i101_31r1f,
  _icn,_pfx,
  i101i10r1k,
  i101i1111f,
  i101a1111i,i101a1112i,i101a1113i,
  i101a1121i,i101a1122i,i101a1123i,
  i101a1211i,i101a1212i,i101a1213i,
  i101a1221i,i101a1222i,i101a1223i,
  "createdAt","updatedAt",_dlt
) VALUES (
  21,1,1,21,
  1,1,
  '1', '午前',
  2,
  11,
  300,300,300, 300,300,300, 300,300,300, 300,300,300,
  '2000-01-01 00:00:00','2000-01-01 00:00:00',-1
);

insert into i101s (
  _key,_vsn,_ltt,_fst,
  _dmn,i101_31r1f,
  _icn,_pfx,
  i101i10r1k,
  i101i1111f,
  i101a1111i,i101a1112i,i101a1113i,
  i101a1121i,i101a1122i,i101a1123i,
  i101a1211i,i101a1212i,i101a1213i,
  i101a1221i,i101a1222i,i101a1223i,
  "createdAt","updatedAt",_dlt
) VALUES (
  22,1,1,22,
  1,1,
  '2', '午後1',
  2,
  12,
  300,300,300, 300,300,300, 300,300,300, 300,300,300,
  '2000-01-01 00:00:00','2000-01-01 00:00:00',-1
);

insert into i101s (
  _key,_vsn,_ltt,_fst,
  _dmn,i101_31r1f,
  _icn,_pfx,
  i101i10r1k,
  i101i1111f,
  i101a1111i,i101a1112i,i101a1113i,
  i101a1121i,i101a1122i,i101a1123i,
  i101a1211i,i101a1212i,i101a1213i,
  i101a1221i,i101a1222i,i101a1223i,
  "createdAt","updatedAt",_dlt
) VALUES (
  23,1,1,23,
  1,1,
  '3', '午後2',
  2,
  13,
  300,300,300, 300,300,300, 300,300,300, 300,300,300,
  '2000-01-01 00:00:00','2000-01-01 00:00:00',-1
);

insert into i101s (
  _key,_vsn,_ltt,_fst,
  _dmn,i101_31r1f,
  _icn,_pfx,
  i101i10r1k,
  i101i1111f,
  i101a1111i,i101a1112i,i101a1113i,
  i101a1121i,i101a1122i,i101a1123i,
  i101a1211i,i101a1212i,i101a1213i,
  i101a1221i,i101a1222i,i101a1223i,
  "createdAt","updatedAt",_dlt
) VALUES (
  24,1,1,24,
  1,1,
  '4', '夕方',
  2,
  14,
  300,300,300, 300,300,300, 300,300,300, 200,200,200,
  '2000-01-01 00:00:00','2000-01-01 00:00:00',-1
);


insert into i10rs (
  _key,_vsn,_ltt,_fst,
  _dmn,i10r_31r1f,
  _icn,_pfx,
  i10ri11r1f,
  i10rt1100i,
  i10ra1100i,
  i10ra2100i,
  "createdAt","updatedAt",_dlt
) VALUES (
  2,1,1,2,
  1,1,
  '2','会議室B',
  1,
  10,
  2,
  100,
  '2000-01-01 00:00:00','2000-01-01 00:00:00',-1
);

insert into i101s (
  _key,_vsn,_ltt,_fst,
  _dmn,i101_31r1f,
  _icn,_pfx,
  i101i10r1k,
  i101i1111f,
  i101a1111i,i101a1112i,i101a1113i,
  i101a1121i,i101a1122i,i101a1123i,
  i101a1211i,i101a1212i,i101a1213i,
  i101a1221i,i101a1222i,i101a1223i,
  "createdAt","updatedAt",_dlt
) VALUES (
  21,1,1,21,
  1,1,
  '1', '午前',
  2,
  11,
  300,300,300, 300,300,300, 300,300,300, 300,300,300,
  '2000-01-01 00:00:00','2000-01-01 00:00:00',-1
);

insert into i101s (
  _key,_vsn,_ltt,_fst,
  _dmn,i101_31r1f,
  _icn,_pfx,
  i101i10r1k,
  i101i1111f,
  i101a1111i,i101a1112i,i101a1113i,
  i101a1121i,i101a1122i,i101a1123i,
  i101a1211i,i101a1212i,i101a1213i,
  i101a1221i,i101a1222i,i101a1223i,
  "createdAt","updatedAt",_dlt
) VALUES (
  22,1,1,22,
  1,1,
  '2', '午後1',
  2,
  12,
  300,300,300, 300,300,300, 300,300,300, 300,300,300,
  '2000-01-01 00:00:00','2000-01-01 00:00:00',-1
);

insert into i101s (
  _key,_vsn,_ltt,_fst,
  _dmn,i101_31r1f,
  _icn,_pfx,
  i101i10r1k,
  i101i1111f,
  i101a1111i,i101a1112i,i101a1113i,
  i101a1121i,i101a1122i,i101a1123i,
  i101a1211i,i101a1212i,i101a1213i,
  i101a1221i,i101a1222i,i101a1223i,
  "createdAt","updatedAt",_dlt
) VALUES (
  23,1,1,23,
  1,1,
  '3', '午後2',
  2,
  13,
  300,300,300, 300,300,300, 300,300,300, 300,300,300,
  '2000-01-01 00:00:00','2000-01-01 00:00:00',-1
);

insert into i101s (
  _key,_vsn,_ltt,_fst,
  _dmn,i101_31r1f,
  _icn,_pfx,
  i101i10r1k,
  i101i1111f,
  i101a1111i,i101a1112i,i101a1113i,
  i101a1121i,i101a1122i,i101a1123i,
  i101a1211i,i101a1212i,i101a1213i,
  i101a1221i,i101a1222i,i101a1223i,
  "createdAt","updatedAt",_dlt
) VALUES (
  24,1,1,24,
  1,1,
  '4', '夕方',
  2,
  14,
  300,300,300, 300,300,300, 300,300,300, 200,200,200,
  '2000-01-01 00:00:00','2000-01-01 00:00:00',-1
);

insert into i10rs (
  _key,_vsn,_ltt,_fst,
  _dmn,i10r_31r1f,
  _icn,_pfx,
  i10ri11r1f,
  i10rt1100i,
  i10ra1100i,
  i10ra2100i,
  "createdAt","updatedAt",_dlt
) VALUES (
  3,1,1,3,
  1,1,
  '3','会議室AB',
  1,
  20,
  1,
  150,
  '2000-01-01 00:00:00','2000-01-01 00:00:00',-1
);

insert into i101s (
  _key,_vsn,_ltt,_fst,
  _dmn,i101_31r1f,
  _icn,_pfx,
  i101i10r1k,
  i101i1111f,
  i101a1111i,i101a1112i,i101a1113i,
  i101a1121i,i101a1122i,i101a1123i,
  i101a1211i,i101a1212i,i101a1213i,
  i101a1221i,i101a1222i,i101a1223i,
  "createdAt","updatedAt",_dlt
) VALUES (
  31,1,1,31,
  1,1,
  '1', '午前',
  3,
  11,
  500,500,500, 500,500,500, 500,500,500, 500,500,500,
  '2000-01-01 00:00:00','2000-01-01 00:00:00',-1
);

insert into i101s (
  _key,_vsn,_ltt,_fst,
  _dmn,i101_31r1f,
  _icn,_pfx,
  i101i10r1k,
  i101i1111f,
  i101a1111i,i101a1112i,i101a1113i,
  i101a1121i,i101a1122i,i101a1123i,
  i101a1211i,i101a1212i,i101a1213i,
  i101a1221i,i101a1222i,i101a1223i,
  "createdAt","updatedAt",_dlt
) VALUES (
  32,1,1,32,
  1,1,
  '2', '午後1',
  3,
  12,
  500,500,500, 500,500,500, 500,500,500, 500,500,500,
  '2000-01-01 00:00:00','2000-01-01 00:00:00',-1
);

insert into i101s (
  _key,_vsn,_ltt,_fst,
  _dmn,i101_31r1f,
  _icn,_pfx,
  i101i10r1k,
  i101i1111f,
  i101a1111i,i101a1112i,i101a1113i,
  i101a1121i,i101a1122i,i101a1123i,
  i101a1211i,i101a1212i,i101a1213i,
  i101a1221i,i101a1222i,i101a1223i,
  "createdAt","updatedAt",_dlt
) VALUES (
  33,1,1,33,
  1,1,
  '3', '午後2',
  3,
  13,
  500,500,500, 500,500,500, 500,500,500, 500,500,500,
  '2000-01-01 00:00:00','2000-01-01 00:00:00',-1
);

insert into i101s (
  _key,_vsn,_ltt,_fst,
  _dmn,i101_31r1f,
  _icn,_pfx,
  i101i10r1k,
  i101i1111f,
  i101a1111i,i101a1112i,i101a1113i,
  i101a1121i,i101a1122i,i101a1123i,
  i101a1211i,i101a1212i,i101a1213i,
  i101a1221i,i101a1222i,i101a1223i,
  "createdAt","updatedAt",_dlt
) VALUES (
  34,1,1,34,
  1,1,
  '4', '夕方',
  3,
  14,
  500,500,500, 500,500,500, 500,500,500, 300,300,300,
  '2000-01-01 00:00:00','2000-01-01 00:00:00',-1
);

insert into i102s (
  _key,_vsn,_ltt,_fst,
  _dmn,i102_31r1f,
  i102i10r1k,
  i102i10r1f,
  "createdAt","updatedAt",_dlt
) VALUES (
  31,1,1,31,
  1,1,
  3,
  1,
  '2000-01-01 00:00:00','2000-01-01 00:00:00',-1
);

insert into i102s (
  _key,_vsn,_ltt,_fst,
  _dmn,i102_31r1f,
  i102i10r1k,
  i102i10r1f,
  "createdAt","updatedAt",_dlt
) VALUES (
  32,1,1,32,
  1,1,
  3,
  2,
  '2000-01-01 00:00:00','2000-01-01 00:00:00',-1
);

 */

import * as _hm from './_hf';
import * as _hmFTH from './_hmFTH';
import * as _ht from './_ht';

export const grtPzForLoadI10rPs = (uz: _ht.uz, pz: {// 団体が指定されていない場合、団体種別において利用不可となっている部屋が考慮されないことに留意
  _31r_fst?: _ht.n,
  i1zr_fst?: _ht.n,
  i10r_fst?: _ht.n,
  i10rt1100i?: _ht.n,
  i10r_fsts?: _ht.ls,
  i18r_fst?: _ht.n, // 団体が指定されていない場合、団体種別において利用不可となっている部屋が考慮されないことに留意
  i102i10r1f?: _ht.n,
  lwrz?: {
    i11rs?: _ht.b,
    i111s?: _ht.b,
    i101s?: _ht.b,
    i102s?: _ht.b,
    i10rsAll?: _ht.b,
  },
}) => {
  let _cdn = _hmFTH.vdd(uz);
  if (pz._31r_fst && pz._31r_fst > 0) _cdn += ` AND i10r_31r1f=${pz._31r_fst}`;
  if (pz?.i1zr_fst) {
    _cdn += ` AND _fst IN (
      SELECT 
        i1z1i10r1f 
      FROM 
        i1z1s 
      WHERE 
        COALESCE(_dlt,-1)<>1 AND 
        i1z1i1zr1k IN ( 
          SELECT 
            _key 
          FROM 
            i1zrs 
          WHERE 
            COALESCE(_dlt,-1) <> 1 AND _vsn = _ltt AND 
            _fst = ${pz?.i1zr_fst}
        )
    )`;
  }
  if (_hm.f(pz?.i10r_fst)) 
    _cdn += ` AND _fst <> ${pz?.i10r_fst}`;
  if (_hm.f(pz?.i10rt1100i)) 
    _cdn += ` AND i10rt1100i = ${pz?.i10rt1100i}`;
  if (_hm.f(pz?.i10r_fsts)) 
    _cdn += ` AND _fst IN (${_hm.join(pz?.i10r_fsts)})`;
  if (_hm.f(pz?.i18r_fst)) { // 団体の属する団体種別において許可されていない部屋を除く
    _cdn += ` AND _fst NOT IN (
      SELECT
        i151i10r1f
      FROM
        i151s
      WHERE
        ${_hmFTH.vdd(uz, { bVsn: false })}
        AND i151i15r1k = (
          SELECT
            _key
          FROM
            i15rs
          WHERE
            ${_hmFTH.vdd(uz)}
            AND _fst = (
              SELECT
                i18ri15r1f
              FROM
                i18rs
              WHERE
                ${_hmFTH.vdd(uz)}
                AND _fst = ${pz?.i18r_fst}
            )
        )
    )`;
  }
  if (_hm.f(pz?.i102i10r1f)) {
    _cdn += ` AND _key IN (
      SELECT
        i102i10r1k
      FROM
        i102s
      WHERE
        ${_hmFTH.vdd(uz)}
        AND i102i10r1f = ${pz?.i102i10r1f}
    )`;
  }
  //_hm.l(`ihdI10 534: ${_cdn}`)
  return { // als の表記を変更すると Aby や 通常予約ボタンの表示に影響があるので注意
    tgt: 'i10rs',
    cdn: _cdn,
    lwrz: {
      i11rs: 
        pz.lwrz?.i11rs || pz.lwrz?.i111s || pz.lwrz?.i101s ?
        {
          tgt: 'i11rs',
          cdn: _hmFTH.vdd(uz) + ` AND _fst = {i11r_fst}`,
          rlcz: {
            'i11r_fst': 'i10rs.i10ri11r1f',
          },
          lwrz: {
            i111s: 
              pz.lwrz?.i111s || pz.lwrz?.i101s ?
              {
                tgt: 'i111s',
                fld: '_fst as key, _pfx as pfx, *',
                cdn: _hmFTH.vdd(uz) + ` AND i111i11r1k = {i11r_key}`,
                rlcz: {
                  'i11r_key': 'i11rs._key'
                },
                tailz: {
                  odr: '_icn',
                },
                lwrz: {
                  i101s: 
                    pz.lwrz?.i101s ?
                    {
                      tgt: 'i101s',
                      cdn: _hmFTH.vdd(uz) + ` AND i101i10r1k = {i10r_key} AND i101i1111f = {i111_fst}`,
                      rlcz: {
                        i10r_key: 'i10rs._key',
                        i111_fst: 'i111s._fst',
                      }
                    }
                    : undefined
                }
              }
              : undefined
          }
        }
        : undefined,

      i102s:
        pz.lwrz?.i102s ? 
        { // 子部屋
          tgt: 'i102s',
          cdn: _hmFTH.vdd(uz, { bVsn: false }) + ` AND i102i10r1k={i10r_key}`,
          rlcz: {
            i10r_key: 'i10rs._key',
          },
          tailz: {
            odr: 'i102i10r1f',
          },
          lwrz: {
            i10rs: {
              tgt: 'i10rs',
              cdn: _hmFTH.vdd(uz, { bVsn: false }) + ` AND _fst = {i102i10r1f}`,
              rlcz: {
                i102i10r1f : 'i102s.i102i10r1f'
              }
            }
          },
        }
        : undefined,
      i10rsAll:
        pz.lwrz?.i10rsAll ?
        {
          tgt: 'i10rs',
          cdn: _hmFTH.vdd(uz) + ` AND (
            _fst = {i10r_fst} -- 自身
            OR _fst IN ( -- 子部屋
              SELECT
                i102i10r1f
              FROM
                i102s
              WHERE
                ${_hmFTH.vdd(uz)}
                AND i102i10r1k = {i10r_key}
            )
            OR _key IN ( -- 親部屋
              SELECT
                i102i10r1k
              FROM
                i102s
              WHERE
                ${_hmFTH.vdd(uz)}
                AND i102i10r1f = {i10r_fst}
            )
          )`,
          rlcz: {
            i10r_fst: 'i10rs._fst',
            i10r_key: 'i10rs._key',
          },
        }
        : undefined

    },
    cvt: (_i10rs: _ht.ls) => {
      //_i10rs.map((_i10rz: _ht.dz) => {
      //  _hm.l(`ihdI10 636: ${_i10rz._fst}`)
      //})
      return _i10rs.map((_i10rz: _ht.dz) => { // ism も直すように注意
        if (!_i10rz.crlz) {
          _i10rz.crlz = {};
        }
        _i10rz.crlz.i10r_fstsAll = _i10rz?.cldz?.i10rsAll?.map((_i10rz: _ht.dz) => _i10rz._fst); // 単体部屋・複合部屋
        _i10rz.crlz.i10r_fstsSglAll = _i10rz?.cldz?.i10rsAll?.filter((_i10rz: _ht.dz) => _i10rz.i10rt1100i != 20).map((_i10rz: _ht.dz) => _i10rz._fst); // 単体部屋のみ
//_hm.l(`ihdI10 639: ${_i10rz._fst}, ${_hm.s(_i10rz)}`)
//_hm.l(`ihdI10 639: ${_i10rz._fst}`)
        return _i10rz;
      });
    },
  }
};

export const i10z = {
  i10r: { // 部屋
    v0: {
      itlz: {
        i10r_31r1f: -1,
        i10ri11r1f: -1,
        i10rt1100i: -1,
        i10ra1100i: 1,
        i10ra2100i: 0,
        i10ra3100s: '',
      },
      fldz: {
        i10r_31r1f: {
          pfx: '施設' 
        },
        i10ri11r1f: {
          pfx: '時間帯区分',
        },
        i10rt1100i: {
          pfx: '部屋種別',
          ls: [
            //{ key: -1, pfx: ' ' },
            { key: 10, pfx: '単体' },
            { key: 20, pfx: '複合' },
          ],
        },
        i10ra1100i: {
          pfx: '連続可能コマ数',
        },
        i10ra2100i: {
          pfx: '１時間あたりの延長料',
        },
        i10ra3100s: {
          pfx: '外部連携部屋ID',
        },
      },
    },
  },
  i101: { // 利用料
    v0: {
      itlz: {
        i101_31r1f: -1,
        i101i10r1k: -1,
        i101i1111f: -1,
        i101a1111i: 0,
        i101a1211i: 0,
        i101a1112i: 0,
        i101a1212i: 0,
        i101a1113i: 0,
        i101a1213i: 0,
        i101a1121i: 0,
        i101a1221i: 0,
        i101a1122i: 0,
        i101a1222i: 0,
        i101a1123i: 0,
        i101a1223i: 0,
      },
      fldz: {
        i101_31r1f: {
          pfx: '施設' 
        },
        i101i10r1k: {
          pfx: '部屋',
        },
        i101i1111f: {
          pfx: '時間帯',
        },
        i101d1110s: {
          pfx: '摘要開始日',
        },
        i101d1120s: {
          pfx: '摘要終了日',
        },
        i101a1111i: {
          pfx: '利用料／１種／通常／平日',
        },
        i101a1211i: {
          pfx: '利用料／２種／通常／平日',
        },
        i101a1112i: {
          pfx: '利用料／１種／通常／土曜',
        },
        i101a1212i: {
          pfx: '利用料／２種／通常／土曜',
        },
        i101a1113i: {
          pfx: '利用料／１種／通常／日祝',
        },
        i101a1213i: {
          pfx: '利用料／２種／通常／日祝',
        },
        i101a1121i: {
          pfx: '利用料／１種／夏時間／平日',
        },
        i101a1221i: {
          pfx: '利用料／２種／夏時間／平日',
        },
        i101a1122i: {
          pfx: '利用料／１種／夏時間／土曜',
        },
        i101a1222i: {
          pfx: '利用料／２種／夏時間／土曜',
        },
        i101a1123i: {
          pfx: '利用料／１種／夏時間／日祝',
        },
        i101a1223i: {
          pfx: '利用料／２種／夏時間／日祝',
        },
      },
    },
  },
  i102: { // 複合部屋
    v0: {
      itlz: {
        i102_31r1f: -1,
        i102i10r1k: -1,
        i102i10r1f: -1,
      },
      fldz: {
        i102_31r1f: {
          pfx: '施設' 
        },
        i102i10r1k: {
          pfx: '部屋（親）',
        },
        i102i10r1f: {
          pfx: '部屋（子）',
        },
      },
    },
  },
};
